import { request } from "./transport";

// Body shape mirrors the browser's native PushSubscription.toJSON():
// `{ endpoint, keys: { p256dh, auth } }`. The controller upserts on
// (user_id, endpoint) so re-subscribes from the same browser replace
// the keys without duplicating rows.
export interface PushSubscribeInput {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export const pushSubscriptions = {
  registerPushSubscription: (input: PushSubscribeInput) =>
    request<{ ok: true; id: string }>("/push_subscriptions", {
      method: "POST",
      body: JSON.stringify(input),
    }),

  unregisterPushSubscription: (endpoint: string) =>
    request<{ ok: true }>("/push_subscriptions", {
      method: "DELETE",
      body: JSON.stringify({ endpoint }),
    }),
};
